export const DEV_UUID = 'storybook'
